(function () {
  function addAutoplay (src) {
    if (src.indexOf('autoplay=1') !== -1) {
      return src
    }

    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'autoplay=1'
  }

  function initGettingStartedVideo () {
    var video = document.getElementById('su-admin-about-getting-started-video')
    var button = document.getElementById('su-admin-about-getting-started-video-button')
    var iframe = document.getElementById('su-admin-about-getting-started-video-iframe')

    if (!video || !button || !iframe) {
      return
    }

    video.classList.remove('su-admin-about-getting-started-video-loading')
    button.classList.remove('su-admin-u-hidden')

    button.addEventListener('click', function () {
      iframe.src = addAutoplay(iframe.src)
      button.classList.add('su-admin-u-hidden')
      iframe.classList.remove('su-admin-u-hidden')
    })
  }

  document.addEventListener('DOMContentLoaded', initGettingStartedVideo)
})()
